module.exports = __webpack_public_path__ + "static/media/plujaGelant.a2cc1fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/plujaGelant.svg
// module id = 826
// module chunks = 0